import { BaseRestfulService } from "./base";
import { ServiceURL } from "./url";

export class OrderService extends BaseRestfulService {
    async send(product_id, period_count, recipient) {
        return this.post(ServiceURL.order.send(), {
            product_id,
            period_count,
            recipient
        });
    }
}
